'use strict';
const angular = require('angular');

export class targetDateChangeFormComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.data.targetDate)
      this.targetDate = new Date(this.config.data.targetDate);
  };

  openTargetDatePopup() {
    this.targetDatePopupOpened = true;
  }

  ok() {
    this.close({$value: {
      targetDate: this.targetDate,
      note: this.note
    }});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.targetDateChangeForm', [])
  .component('targetDateChangeForm', {
    template: require('./target-date-change-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: targetDateChangeFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/target-date-change-form/target-date-change-form.component.js